module.exports = __webpack_public_path__ + "static/media/roo_wor_oh_lin.b2279ab1.png";